var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarlocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.435838 1.09894C0.467753 1.07454 0.504932 1.05757 0.544554 1.04932C0.584174 1.04107 0.625197 1.04176 0.664505 1.05134L4.83517 2.07133L9.01384 0.0274279C9.07082 -0.000374188 9.13608 -0.00731414 9.19784 0.00786285L13.4645 1.05133C13.5222 1.06544 13.5734 1.09801 13.61 1.14386C13.6466 1.1897 13.6665 1.2462 13.6665 1.30438L13.6665 10.6956C13.6666 10.7355 13.6573 10.7748 13.6394 10.8106C13.6215 10.8464 13.5955 10.8777 13.5633 10.9022C13.5311 10.9266 13.4937 10.9435 13.4538 10.9516C13.4139 10.9596 13.3726 10.9586 13.3332 10.9487L9.1625 9.92867L4.98384 11.9726C4.92686 12.0004 4.86159 12.0073 4.79984 11.9921L0.533173 10.9487C0.475853 10.9342 0.425088 10.9015 0.388877 10.8556C0.352666 10.8098 0.333069 10.7535 0.333173 10.6956L0.333172 1.30438C0.333213 1.26476 0.34248 1.22566 0.360269 1.19007C0.378058 1.15447 0.403901 1.12331 0.435838 1.09894ZM8.8665 0.682859L5.13317 2.50894L5.13317 11.3171L8.8665 9.49107L8.8665 0.682859ZM13.1332 1.50785L9.39984 0.594816L9.39984 9.44867L13.1332 10.3617L13.1332 1.50785ZM0.866506 10.4921L4.59984 11.4052L4.59984 2.55133L0.866505 1.63829L0.866506 10.4921Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlocation);
export default __webpack_public_path__ + "static/media/carlocation.08153e520b4715ca924c09f99696cf48.svg";
export { ForwardRef as ReactComponent };